<div [ngClass]="{'tap-top': showScroll}" (click)="onActivate()">
  <div><i class="fa fa-angle-up"></i></div>
</div>
